import { IconName } from "src/globalTypes";
import { TableColumns } from "src/requests/table/types";
import {
  ColumnFormat,
  ColumnFormatDict,
  TextAlign,
} from "../../../../../requests/templates/types";
import {
  BOTH,
  ICON,
  LEFT,
  TEXT,
} from "../../../TemplateBuilder/TemplateItemEditor/FormatEditor/constants";
import { ColumnLabelOverrides } from "../../types";

export interface IMappedHeadColumns {
  isHidden: boolean;
  columnKey: string;
  icon: IconName;
  textAlign: TextAlign;
  displayIcon: boolean;
  displayText: boolean;
  orderKey: string;
  columnLabel: string;
}

export const getMappedTableHeadColumns = (
  columns: TableColumns,
  columnFormatDict: ColumnFormatDict,
  columnLabelOverrides: ColumnLabelOverrides = {}
): IMappedHeadColumns[] =>
  Object.entries(columns).map(([columnKey, column]) => {
    const { inputType, templateItemId, displayName } = column;

    const isHidden = inputType === "hidden";
    const columnFormat: ColumnFormat | undefined =
      columnFormatDict[templateItemId];

    const labelFormat = columnFormat?.label || {};
    const { textAlign = LEFT, icon = "", variant = TEXT } = labelFormat;

    const displayIcon = !!icon && (variant === ICON || variant === BOTH);
    const displayText = variant === TEXT || variant === BOTH;

    const orderKey = String(column.columnAlias);
    const columnLabel = columnLabelOverrides[columnKey] ?? displayName;

    return {
      isHidden,
      columnKey,
      icon,
      textAlign,
      displayIcon,
      displayText,
      orderKey,
      columnLabel,
    };
  });
